import React from 'react';
import {
  ContactsOutlined,
  EuroOutlined,
  FieldTimeOutlined,
  SettingOutlined,
  StockOutlined,
  TagsOutlined,
  ContainerOutlined,
  UsergroupAddOutlined
} from '@ant-design/icons';
import {
  HomeIcon,
  ProjectsIcon,
  UsersIcon,
  DashboardIcon,
  IndicatorIcon,
  ReportingIcon,
  BalanceIcon,
  HistoryIcon
} from './customIcon';

const navMenuLogos = {
  HOME: <HomeIcon />,
  DASHBOARD: <DashboardIcon />,
  REPORTING: <ReportingIcon />,
  INDICATORS: <IndicatorIcon />,
  HISTORY: <HistoryIcon />,
  BALANCE_SHEET: <BalanceIcon />,
  MEMBERS: <UsergroupAddOutlined />,
  ACCOUNTING: <EuroOutlined />,
  COMMERCIAL: <ContactsOutlined />,
  PROJECTS: <ProjectsIcon />,
  THEME: <SettingOutlined />,
  DOCUMENTS: <ContainerOutlined style={{ fontSize: 35 }} />,
  'TIMES-AND-ATTENDANCES': <FieldTimeOutlined />,
  PRODUCTION: <StockOutlined />,
  TICKETS: <TagsOutlined />,
  USERS: <UsersIcon />
};

export default navMenuLogos;
